import { render, staticRenderFns } from "./DialogBoardsideType.vue?vue&type=template&id=b599d068&scoped=true&"
import script from "./DialogBoardsideType.vue?vue&type=script&lang=js&"
export * from "./DialogBoardsideType.vue?vue&type=script&lang=js&"
import style0 from "./DialogBoardsideType.vue?vue&type=style&index=0&id=b599d068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b599d068",
  null
  
)

export default component.exports